// import {paymentDetail} from './request';
export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false,
      disabled: false
    };
  },
  computed: {
    dataRule() {
      return {
        peopleNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('公司现有人数')
        }],
        licensesNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('总持证数')
        }],
        adminNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('高级管理人员')
        }],
        adminLicensesNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('高级管理人员持证数数')
        }],
        businessNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('业务人员人数')
        }],
        businessLicensesNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('业务人员持证数')
        }],
        onBusinessNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('非业务人员人数')
        }],
        onBusinessLicensesNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('非业务人员持证数')
        }],
        grew: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('同比')
        }]
      };
    }
  },
  methods: {
    init(val) {
      this.dataFrom = val || {};
      this.disabled = val ? true : false;
      // paymentDetail({orderId:id}).then(res=>{
      //     console.log(res);
      //     this.dataFrom=res;
      // });
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.$emit('cancel');
          this.$emit('ok', this.dataFrom);
        }
      });
    }
  }
};